import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import * as actions from "../actions/gkns";
import {
  GET_TK_GKN_ADMIN_REQUEST,
  DELETE_TK_ADMIN_GKN_REQUEST,
  CREATE_TK_ADMIN_GKN_REQUEST,
  EDIT_TK_ADMIN_GKN_REQUEST,
} from "../actionTypes";
import { apiCall } from "../../helpers/api";
import { customSwal } from "../../helpers/customSwal";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";

function* watchGetTKGKNs() {
  yield takeEvery(GET_TK_GKN_ADMIN_REQUEST, getTKGKNs);
}

function* watchCreateTKGKN() {
  yield takeEvery(CREATE_TK_ADMIN_GKN_REQUEST, createTKGKN);
}

function* watchEditTKGKN() {
  yield takeEvery(EDIT_TK_ADMIN_GKN_REQUEST, editTKGKN);
}

function* watchDeleteTKGKN() {
  yield takeEvery(DELETE_TK_ADMIN_GKN_REQUEST, deleteTKGKN);
}

function* getTKGKNs(action) {
  try {
    const res = yield call(apiCall, "get", "public/genckartnedir");
    yield put(
      actions.getTKGKNAdminSucceeded({
        data: [...res.data.data],
      })
    );
  } catch (err) {
    yield put(actions.getTKGKNAdminFailed());
  }
}

function* createTKGKN(action) {
  const { data } = action.payload;
  const { caption, detail, order_number } = data;
  try {
    const res = yield call(apiCall, "post", "api/loyalty/genckartnedir", {
      type: "genckartnedir",
      caption,
      detail: JSON.stringify(convertToRaw(data.detail.getCurrentContent())),
      order_number,
    });
    yield put(actions.setShowGKNAddModal(false));
    yield put(actions.getTKGKNAdminRequest());
  } catch (err) {
    yield put(actions.getTKGKNAdminFailed());
  }
}

function* editTKGKN(action) {
  const { data, selectedId } = action.payload;
  const { caption, detail, order_number } = data;

  try {
    const res = yield call(
      apiCall,
      "put",
      `api/loyalty/genckartnedir/${selectedId}`,
      {
        type: "genckartnedir",
        caption,
        detail:
          typeof data.detail == "object"
            ? JSON.stringify(convertToRaw(data.detail.getCurrentContent()))
            : data.detail,
        order_number,
      }
    );
    yield put(actions.setShowGKNEditModal(false));
    yield put(actions.getTKGKNAdminRequest());
  } catch (err) {
    yield put(actions.getTKGKNAdminFailed());
  }
}

function* deleteTKGKN(action) {
  try {
    const { selectedId } = action.payload;
    yield call(
      apiCall,
      "put",
      `api/loyalty/genckartnedir/${selectedId}/delete`
    );
    yield call(customSwal, "Başarılı", "Kampanya başarıyla silindi", "success");
    yield put(actions.setShowGKNDeleteModal(false));
    yield put(actions.getTKGKNAdminRequest());
  } catch (err) {
    yield put(actions.getTKGKNAdminFailed());
    yield call(
      customSwal,
      "Hata",
      "Yanlış bir şey oldu, lütfen tekrar deneyiniz",
      "error"
    );
  }
}

export default function* GKNsSaga() {
  yield all([
    fork(watchGetTKGKNs),
    fork(watchCreateTKGKN),
    fork(watchEditTKGKN),
    fork(watchDeleteTKGKN),
  ]);
}
